import React, { useEffect } from 'react'
import id_icon from "./assets/id_icon.png"

const styles = {
    textContainer: {
        width: '322px',
        height: '142px',
        background: 'rgba(0, 0, 0, 0.3)',
        borderRadius: '18px',
        color: "#fff"
    },
    head: {
        fontFamily: 'Inter',
        fontWeight: '500',
        fontSize: '18px',
        lineHeight: '24px',
        height: '43px',
        background: 'rgba(0, 0, 0, 0.3)',
        borderRadius: '18px 18px 0px 0px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    middle: {
        fontFamily: 'Inter',
        fontWeight: '500',
        fontSize: '16px',
        lineHeight: '26px',
        textAlign: 'center'
    }
}

function IdTipOverlay(props) {

    const handleTapToFocus = (event) => {
            if (window.CameraPreview) {
                const xPoint = event.clientX;
                const yPoint = event.clientY;
        
                window.CameraPreview.tapToFocus(
                    xPoint,
                    yPoint,
                    () => console.log(`Focus success at (${xPoint}, ${yPoint})`),
                    (error) => console.error("Focus error:", error)
                );
            }
        };

useEffect(()=>{
    const previewContainer = document.getElementById("idTipOverlayContainer");
    if (previewContainer) {
        console.log("adding event lister for tap to focus on mounting");    
        previewContainer.addEventListener("click", handleTapToFocus);
    }

    return ()=>{
        if (previewContainer) {
            console.log("removing event lister for tap to focus on unmounting");      
            previewContainer.removeEventListener("click", handleTapToFocus);
        }
    }

},[])

    return (
        <div class={`id-overlay driving-license`} > {/* {`id-overlay ${props.selectedIdType.toLowerCase() == "passport" ? "passport" : "driving-license" }`} */}
            <svg id='idTipOverlayContainer' width="314" height="546" viewBox="0 0 314 546" fill="none" xmlns="http://www.w3.org/2000/svg"></svg>
                
            {/* <svg width="374" height="818" viewBox="0 0 374 818" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M374 0H0V818H374V0ZM354 260H20V470H354V260Z" fill="black" fill-opacity="0.3"/>
                <rect x="20" y="260" width="334" height="155" fill="white" fill-opacity="0.3"/>
                <rect x="20" y="415" width="334" height="55" fill="white" fill-opacity="0.1"/>
            </svg> */}

            {/* <div style={styles.textContainer}>
            <div style={styles.head} >
                <img style={{marginRight: '1rem', width: '25px'}} src={id_icon} />
                <text>ID Card Capture</text>
            </div>
            <div style={styles.middle}>
                Make sure that ID Card is within the box during capturing
            </div>
        </div> */}

        </div>
    )
}

export default IdTipOverlay